import { Route } from '@angular/router';
import { LoggedInGuard, LoggedOutGuard } from '@maia/core';
import { environment } from '../environments/environment';

export const appRoutes: Route[] = [
  {
    path: '',
    canMatch: [LoggedOutGuard],
    children: [
      { path: '', pathMatch: 'full', redirectTo: 'applicatie-selecteren' },
      {
        path: 'applicatie-selecteren',
        loadChildren: () => import('@maia/app-selection').then(m => m.AppSelectionRoutes),
      },
    ],
  },
  {
    path: '',
    canMatch: [LoggedInGuard],
    children: [
      { path: '', pathMatch: 'full', redirectTo: 'chat' },
      { path: 'authorize', redirectTo: 'chat' },
      {
        path: 'chat',
        loadChildren: () =>
          import('@maia/chat').then(m => m.chatRoutes({ mockContentful: environment.mockContentful ?? false })),
      },
      { path: 'forbidden', loadChildren: () => import('@maia/authentication').then(m => m.AuthenticationRoutes) },
    ],
  },
  { path: '**', redirectTo: '/' },
];
